import {NgModule} from '@angular/core'
import {DetailProgramDescBulletsComponent} from './detail-program-desc-bullets/detail-program-desc-bullets.component'
import {ModalProgramDescBulletsComponent} from './modal-program-desc-bullets/modal-program-desc-bullets.component'
import {SearchProgramsDescBulletsComponent} from './search-programs-desc-bullets/search-programs-desc-bullets.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {BrowserModule} from '@angular/platform-browser'
import {CommonModule} from '@angular/common'
import {IconsTextModule} from '../icons-text/icons-text.module'
import {DescriptionModule} from '../../description/description.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../../pipes/pipes.module'
import {FormsModule} from '@angular/forms'
import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {SharedModule} from '../../shared/shared.module'

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    IconsTextModule,
    DescriptionModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule
  ],
  declarations: [
    DetailProgramDescBulletsComponent,
    ModalProgramDescBulletsComponent,
    SearchProgramsDescBulletsComponent
  ],
  exports: [
    DetailProgramDescBulletsComponent,
    ModalProgramDescBulletsComponent,
    SearchProgramsDescBulletsComponent
  ],
  providers: []
})
export class ProgramDescBulletsModule {
}
